import { render } from "./siteEmbed.vue?vue&type=template&id=f8c7f90a"
import script from "./siteEmbed.vue?vue&type=script&lang=js"
export * from "./siteEmbed.vue?vue&type=script&lang=js"

import "./siteEmbed.vue?vue&type=style&index=0&id=f8c7f90a&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__